import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonType } from '../enums/button-type.enum';
import { Task } from '../tasks/task';
import { ModalButton } from './buttons/modal-button';

export interface ModalComponentData {
  message: string;
  buttons: ModalButton[];
  customMessage?: boolean;
}

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css'],
    standalone: false
})
export class ModalComponent implements OnInit {
  title: string = ''; // not in use
  message: string = '';
  buttons: ModalButton[] = [];
  SECONDARY_BTN_REF = ButtonType.SECONDARY;
  taskLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: ModalComponentData
  ) {
    if (data) {
      if (data.customMessage && data.customMessage == true){
        this.message = data.message
      }
      else {
        this.message = `<p class="modal-dialog-msg">${data.message}<p>`;
      }
      if (data.buttons) {
        this.buttons = data.buttons;
      }
    }
  }

  executeTask(task: Task) {
    this.enableTaskLoading(true);
    task.execute(this.dialogRef);
  }

  ngOnInit(): void {
    console.log('openend dialog');
  }

  enableTaskLoading(loading: boolean) {
    this.taskLoading = loading;
  }
}
